import CloseButton from 'react-bootstrap/CloseButton';

const CustomCloseButton = ()=> {
  return (
        <CloseButton aria-label="Hide" />
  );
};

export default CustomCloseButton;